import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ObjectiveTask } from '../../models/objectives';
import { ObjectivesService } from '../../services/objectives.service';
import { UpdateTaskDialogComponent } from '../update-task-dialog/update-task-dialog.component';
import { MatIcon } from '@angular/material/icon';
import { NgIf, DatePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'app-my-task-row',
    templateUrl: './my-task-row.component.html',
    styleUrls: ['./my-task-row.component.css'],
    imports: [MatIcon, NgIf, MatButton, MatDivider, DatePipe]
})
export class MyTaskRowComponent implements OnInit {

  @Input() Task: ObjectiveTask;
  @Output() TaskChangedEvent = new EventEmitter<number>();

  constructor(private objectiveService: ObjectivesService,private dialog: MatDialog,) { }

  ngOnInit(): void {
  }

  completeTask(){
    const newObjectiveDialog = this.dialog.open(UpdateTaskDialogComponent, {
      data: {
       Task: this.Task
      }
    });
    newObjectiveDialog.afterClosed().subscribe(result => {
      this.TaskChangedEvent.emit();
     
    });
  }

}
